import React from 'react';

const orange = '#FF6F0F';

const ScreenFrame: React.FC<{ title: string; caption: string; children: React.ReactNode }> = ({
  title,
  caption,
  children,
}) => (
  <figure style={{ margin: 0, width: '100%' }}>
    <div style={{
      background: '#121218',
      border: '1px solid #2E2E3C',
      borderRadius: 16,
      padding: 10,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8, padding: '0 4px' }}>
        <span style={{ width: 8, height: 8, borderRadius: 99, background: '#FF5F57' }} />
        <span style={{ width: 8, height: 8, borderRadius: 99, background: '#FEBC2E' }} />
        <span style={{ width: 8, height: 8, borderRadius: 99, background: '#28C840' }} />
        <span style={{ marginLeft: 6, fontSize: 11, color: '#A7A7BC' }}>{title}</span>
      </div>
      <div style={{ background: '#FFFFFF', color: '#161616', borderRadius: 12, overflow: 'hidden' }}>
        {children}
      </div>
    </div>
    <figcaption style={{ marginTop: 8, fontSize: 12, lineHeight: 1.5, color: '#8E8EA0' }}>
      {caption}
    </figcaption>
  </figure>
);

const Highlight: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({ children, style }) => (
  <div style={{
    boxShadow: `0 0 0 2px ${orange}`,
    borderRadius: 8,
    background: '#FFF4EC',
    ...style,
  }}>
    {children}
  </div>
);

export const MenuFigure: React.FC = () => (
  <ScreenFrame title="마루 아케이드" caption="수업 관리를 누르면 등록 코드가 있습니다. 평가 코드 생성과는 다른 메뉴입니다.">
    <div style={{ padding: 14, background: '#F7F7F8' }}>
      <div style={{ display: 'flex', gap: 8, fontSize: 11, color: '#6B6B76', marginBottom: 12, flexWrap: 'wrap' }}>
        <span>홈</span>
        <span>게임 차트</span>
        <span>게임 스토어</span>
        <span style={{ color: orange, fontWeight: 700 }}>수업 관리</span>
      </div>
      <div style={{ background: '#FFFFFF', borderRadius: 10, border: '1px solid #E6E6EA', overflow: 'hidden', maxWidth: 220 }}>
        {['학급 게임 관리', '학생 관리'].map((label) => (
          <div key={label} style={{ padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #F0F0F0' }}>{label}</div>
        ))}
        <Highlight>
          <div style={{ padding: '10px 12px', fontSize: 13, fontWeight: 700, color: orange }}>등록 코드</div>
        </Highlight>
        <div style={{ padding: '10px 12px', fontSize: 13, color: '#8A8A96' }}>평가 코드 생성</div>
      </div>
    </div>
  </ScreenFrame>
);

export const CodeFormFigure: React.FC = () => (
  <ScreenFrame title="등록 코드" caption="소속은 게임 카드에 그대로 나옵니다. 메모는 선생님만 코드를 구분할 때 씁니다.">
    <div style={{ padding: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>새 코드</div>
      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>소속 *</div>
      <Highlight>
        <div style={{
          border: '1px solid #F0F0F0',
          borderRadius: 8,
          padding: '10px 12px',
          fontSize: 13,
          marginBottom: 6,
        }}>
          3학년 1반
        </div>
      </Highlight>
      <div style={{ fontSize: 11, color: '#989898', marginBottom: 12 }}>이 코드로 등록한 게임에 이 소속이 표시됩니다.</div>
      <div style={{
        border: '1px solid #F0F0F0',
        borderRadius: 8,
        padding: '10px 12px',
        fontSize: 13,
        color: '#989898',
        marginBottom: 12,
      }}>
        메모 (선택) 예: 게임 시간
      </div>
      <div style={{
        display: 'inline-block',
        background: orange,
        color: '#FFFFFF',
        fontWeight: 700,
        fontSize: 13,
        borderRadius: 8,
        padding: '10px 14px',
      }}>
        코드 만들기
      </div>
    </div>
  </ScreenFrame>
);

export const CodeReadyFigure: React.FC = () => (
  <ScreenFrame title="만든 코드" caption="같은 코드를 여러 학생에게 알려도 됩니다. 학생은 이 코드를 게임 등록 페이지에 넣습니다.">
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center' }}>
        <div>
          <Highlight>
            <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: '0.08em', padding: '4px 6px' }}>K7MQ9AB2</div>
          </Highlight>
          <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>소속 3학년 1반 · 게임 시간</div>
        </div>
        <div style={{
          border: '1px solid #E6E6EA',
          borderRadius: 8,
          padding: '8px 12px',
          fontSize: 13,
          fontWeight: 700,
        }}>
          복사
        </div>
      </div>
    </div>
  </ScreenFrame>
);

export const MakeCodeShareFigure: React.FC = () => (
  <ScreenFrame title="메이크코드 아케이드" caption="에디터 위쪽 공유를 누른 뒤 게시합니다. 게시가 끝나야 주소와 임베드 코드가 나옵니다.">
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 12px',
        background: '#F4F6FA',
        borderBottom: '1px solid #E6E6EA',
      }}>
        <div style={{ fontSize: 12, fontWeight: 700 }}>내 게임</div>
        <Highlight>
          <div style={{
            background: orange,
            color: '#FFFFFF',
            fontSize: 12,
            fontWeight: 800,
            borderRadius: 8,
            padding: '6px 10px',
          }}>
            공유
          </div>
        </Highlight>
      </div>
      <div style={{ padding: 14 }}>
        <div style={{
          border: '1px solid #E6E6EA',
          borderRadius: 12,
          padding: 12,
        }}>
          <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 8 }}>프로젝트 공유</div>
          <div style={{ fontSize: 12, color: '#555', marginBottom: 10, lineHeight: 1.5 }}>
            게시하면 다른 사람이 플레이할 수 있는 주소가 만들어집니다.
          </div>
          <div style={{
            display: 'inline-block',
            background: '#111111',
            color: '#FFFFFF',
            fontSize: 12,
            fontWeight: 700,
            borderRadius: 8,
            padding: '8px 12px',
          }}>
            게시
          </div>
        </div>
      </div>
    </div>
  </ScreenFrame>
);

export const EmbedFigure: React.FC = () => (
  <ScreenFrame title="공유 결과" caption="위 주소는 게임 URL, 아래 HTML 전체는 시뮬레이터 코드입니다. 두 칸 모두 마루에 붙여 넣습니다.">
    <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div>
        <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 4 }}>게임 주소</div>
        <Highlight>
          <div style={{
            fontSize: 11,
            padding: '8px 10px',
            borderRadius: 8,
            background: '#F7F7F8',
            wordBreak: 'break-all',
          }}>
            https://makecode.com/_MH2WAy9ieYgU
          </div>
        </Highlight>
      </div>
      <div>
        <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 4 }}>임베드</div>
        <Highlight>
          <div style={{
            fontSize: 11,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            padding: '8px 10px',
            borderRadius: 8,
            background: '#F7F7F8',
            lineHeight: 1.45,
            color: '#333',
          }}>
            {'<iframe src="https://arcade.makecode.com/---codeembed" ...></iframe>'}
          </div>
        </Highlight>
      </div>
    </div>
  </ScreenFrame>
);

export const RegisterCodeFigure: React.FC = () => (
  <ScreenFrame title="게임 등록" caption="코드 확인을 눌러 소속이 보여야 게임 등록 버튼이 켜집니다. 로그인은 필요 없습니다.">
    <div style={{ padding: 14 }}>
      <div style={{ background: '#FFF4EC', borderRadius: 10, padding: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 8 }}>선생님이 알려 준 등록 코드</div>
        <div style={{ display: 'flex', gap: 6 }}>
          <Highlight style={{ flex: 1 }}>
            <div style={{
              border: '1px solid #F0F0F0',
              background: '#FFFFFF',
              borderRadius: 8,
              padding: '8px 10px',
              fontSize: 13,
              letterSpacing: '0.06em',
              fontWeight: 700,
            }}>
              K7MQ9AB2
            </div>
          </Highlight>
          <div style={{
            background: orange,
            color: '#FFFFFF',
            borderRadius: 8,
            padding: '8px 10px',
            fontSize: 12,
            fontWeight: 800,
            whiteSpace: 'nowrap',
          }}>
            코드 확인
          </div>
        </div>
        <div style={{ marginTop: 10, fontSize: 13, fontWeight: 700, color: '#166534' }}>소속: 3학년 1반</div>
      </div>
    </div>
  </ScreenFrame>
);

export const RegisterFieldsFigure: React.FC = () => (
  <ScreenFrame title="입력 칸" caption="별표가 있는 칸은 비우면 등록되지 않습니다. 아이콘은 로그인하지 않으면 올리지 못합니다.">
    <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {[
        ['게임 제목 *', '우주 청소부'],
        ['게임 URL *', 'https://makecode.com/_...'],
        ['시뮬레이터 코드 *', '<iframe ...></iframe>'],
        ['제작자 이름 *', '김마루'],
      ].map(([label, value]) => (
        <div key={label}>
          <div style={{ fontSize: 11, fontWeight: 700, marginBottom: 3 }}>{label}</div>
          <div style={{
            border: '1px solid #F0F0F0',
            borderRadius: 8,
            padding: '7px 10px',
            fontSize: 12,
            background: '#FAFAFA',
          }}>
            {value}
          </div>
        </div>
      ))}
      <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>설명, 소개 문구, 학년, 반은 비워도 됩니다.</div>
    </div>
  </ScreenFrame>
);

export const MyGamesFigure: React.FC = () => (
  <ScreenFrame title="내가 등록한 게임" caption="수정 버튼은 게임을 올린 그 브라우저에만 있습니다. 다른 컴퓨터에서는 선생님에게 수정을 부탁합니다.">
    <div style={{ padding: 14 }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{
          width: 72,
          height: 72,
          borderRadius: 12,
          background: 'linear-gradient(145deg, #FF8A3D, #FF6F0F)',
          color: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 28,
          fontWeight: 800,
          flexShrink: 0,
        }}>
          우
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 800 }}>우주 청소부</div>
          <div style={{ fontSize: 12, color: '#666', margin: '4px 0 8px' }}>김마루 · 3학년 1반</div>
          <Highlight>
            <div style={{
              display: 'inline-block',
              border: '1px solid #E6E6EA',
              borderRadius: 8,
              padding: '6px 10px',
              fontSize: 12,
              fontWeight: 700,
              background: '#FFFFFF',
            }}>
              수정
            </div>
          </Highlight>
        </div>
      </div>
    </div>
  </ScreenFrame>
);
